import React from "react";
import { LuCalendar } from "react-icons/lu";

import DetailSection from "./DetailSection";
import { formatGujaratiLongDateTime } from "../../static/materialLine";
import { LineUserProps } from "../../types/materialLine";

type Props = {
  creator?: LineUserProps | null;
  updater?: LineUserProps | null;
  createdAt: string;
  updatedAt: string;
};

const userText = (user?: LineUserProps | null) =>
  user ? (user.phone ? `${user.name} (${user.phone})` : user.name) : "-";

// Who added the order or purchase and when, and who last edited it ("-" until someone does) and when it last changed.
const DetailAccountInfo = ({ creator, updater, createdAt, updatedAt }: Props) => {
  const items = [
    { label: "બનાવ્યાની તારીખ", user: creator, date: createdAt },
    { label: "છેલ્લે અપડેટ કર્યું", user: updater, date: updatedAt },
  ];

  return (
    <DetailSection title="એકાઉન્ટ માહિતી">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {items.map((item) => (
          <div key={item.label} className="flex items-center gap-3">
            <LuCalendar className="h-5 w-5 shrink-0 text-[#34699A]" />
            <div className="min-w-0">
              <p className="text-sm text-gray-500">{item.label}</p>
              <p className="break-words font-medium">{userText(item.user)}</p>
              <p className="font-medium">
                {formatGujaratiLongDateTime(item.date)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </DetailSection>
  );
};

export default DetailAccountInfo;
